import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
class ComponentSelect extends Component {
    constructor(props) {
        super(props);
        this.clear = this.clear.bind(this);
        this.setValue = this.setValue.bind(this);
        // Start by setting a default value.
        const defaultValue = props.defaultValue || props.options[0].value;
        this.setValue(defaultValue);
    }
    /**
     * On change event listener.
     *
     * @param {string} value
     *   The value of the select.
     */
    onChange(value) {
        const { onChange } = this.props;
        this.setValue(value, true);
        // Call any onChange event listener on the parent component.
        if (onChange) {
            onChange(this.selected, this.value);
        }
    }
    /**
     * Setter for value.
     *
     * @param {string} input
     *   Either a label or a value of an option to set.
     * @param {boolean} forceUpdate
     *   Whether or not to update the component.
     */
    setValue(input, forceUpdate = false) {
        const { options } = this.props;
        // Iterate the options to find the right option.
        options.forEach((option) => {
            if (option.label === input || option.value === input) {
                this.selected = option.value;
                this.value = option.label;
            }
        });
        if (forceUpdate) {
            this.forceUpdate();
        }
    }
    /**
     * Clear the select.
     */
    clear() {
        const { defaultValue, options } = this.props;
        // Either use the specified defaultValue as initial value, or
        // the value of the first option.
        const newDefaultValue = defaultValue || options[0].value;
        this.setValue(newDefaultValue, true);
    }
    render() {
        const { options } = this.props;
        return (_jsx("select", Object.assign({ value: this.selected, onChange: (e) => { this.onChange(e.currentTarget.value); }, required: true }, { children: options.map((option) => _jsx("option", Object.assign({ value: option.value }, { children: option.label }), option.value)) })));
    }
}
ComponentSelect.propTypes = {
    options: PropTypes.array.isRequired,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func
};
ComponentSelect.defaultProps = { defaultValue: '' };
export default ComponentSelect;
